import HTTP from '../http'
const BASE_URL = '/tsg-author/web'
export default {
  /**
  * 百科在线，期刊查询
  * @param {Object} name 查询参数 
  * @returns 
  */
  bkzxNoLimi(params) {
    return HTTP.get(BASE_URL + '/encyclopedia/bkzxNoLimitList', params)
  },
  paperQuery(params) {
    return HTTP.get(BASE_URL + '/paper/paperBk', params)
  },

  //论文详情
  defense(params) {
    return HTTP.get(BASE_URL + '/paper/paperDetail', params)
  },
}